import Model from '../utils/Model'

class ClearingType {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'ClearingType'

export const CLEARING_NORMAL = new ClearingType(0, 'Normal', '普通')
export const CLEARING_MONTHLY = new ClearingType(1, 'Monthly', '月结')

export const CLEARING_TYPES = [CLEARING_NORMAL, CLEARING_MONTHLY]

/**
 *  return null:没找到.
 */
export function getClearingTypeByCode(code) {
  return Model.getObjByCode(code, CLEARING_TYPES)
}
